module.exports = __webpack_public_path__ + "media/images/empty-state-email-b3c9a184e35f39f235fd8ee884569bf3.png";